// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"43417dfb","453":"e2749479","672":"be61fc2e","686":"0fa82e41","820":"b2d2e78c","831":"29944df6","933":"99b88145"}[chunkId] + ".chunk.js";
};